import { Text } from '@chakra-ui/react';
import Icon from 'components/atoms/Icon/Icon';
import React from 'react';
import { useGlobalStore } from 'stores/global';
import { TextHitStyled } from './styled/TextHit.styled';
/**
 * TextHit component.
 *
 * This component receives a search hit object and displays a clickable list item.
 * When the list item is clicked, it navigates to a search route with the search query as a parameter,
 * and hides the search display.
 *
 * @component
 * @param {Object} props - Properties passed to the component.
 * @param {Object} props.hit - The search hit data.
 * @param {string} props.hit.objectID - The unique identifier for the hit.
 * @param {string} props.hit.query - The search query string that resulted in this hit.
 *
 * @example
 * // hit object example
 * const hit = {
 *   objectID: '123',
 *   query: 'example query',
 * }
 *
 * return <TextHit hit={hit} />;
 *
 * @returns {React.Element} The rendered component.
 */
const TextHit = ({ hit }) => {
  const { setShowSearch } = useGlobalStore(state => state);

  return (
    <div key={hit.objectID} className="default-hover">
      <a
        href={`/search/?q=${hit.query.toLowerCase()}`}
        target="_self"
        onClick={() => setShowSearch(false)}
      >
        <Icon symbol={'search'} />
        <TextHitStyled>{hit.query.toLowerCase()}</TextHitStyled>
      </a>
    </div>
  );
};

export default TextHit;
